var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortalColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.774799,
    height: 23.02961,
    viewBox: "0 0 25.774799 23.02961",
    fill: "none",
    id: "svg34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_842_527",
    x1: 25.3267,
    y1: 12.0409,
    x2: 0.35578501,
    y2: 9.0602798,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0,-0.4853515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063",
    id: "stop33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640",
    id: "stop34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_842_527",
    x1: 22.215401,
    y1: 11.9182,
    x2: 8.4764299,
    y2: 12.0436,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0,-0.4853515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6",
    id: "stop29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#F03063",
    id: "stop30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FF7640",
    id: "stop31"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m 25.7748,1.0327885 c 0,-0.60533 -0.6121,-1.01979 -1.1774,-0.803192 -7.9798,3.057752 -12.8963,4.143782 -20.95136,4.538612 -0.45983,0.02254 -0.8228,0.40072 -0.8228,0.86109 V 16.444548 c 0,0.4613 0.36435,0.8399 0.82513,0.8614 7.96223,0.3711 12.86143,1.473301 20.89013,5.2036 0.5733,0.266401 1.2363,-0.148099 1.2363,-0.7803 z",
    fill: "url(#paint5_linear_842_527)",
    fillOpacity: 0.13,
    id: "path12",
    style: {
      fill: "url(#paint5_linear_842_527)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 0,1.2300485 c 0,-0.837637 0.821856,-1.428557 1.61787,-1.167804 8.06788,2.642824 12.99873,3.866804 20.32953,4.552144 0.6355,0.05941 1.1269,0.59048 1.1269,1.22875 V 15.950649 c 0,0.603999 -0.4415,1.117799 -1.0374,1.216699 -7.8495,1.303 -12.72522,2.8859 -20.36956,5.7813 C 0.862673,23.253349 0,22.660349 0,21.799848 Z",
    fill: "url(#paint6_linear_842_527)",
    id: "path14",
    style: {
      fill: "url(#paint6_linear_842_527)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalColor);
export default __webpack_public_path__ + "static/media/portal-color.2b7aa9c12d7a3e2fed2e99f01d6acfae.svg";
export { ForwardRef as ReactComponent };